import React from "react";
import { TransformedProduct } from "../../../types/productApiTypes";

interface CardImageProps {
  product: TransformedProduct;
}

/**
 * Renders the main image and hover image for the product card.
 */
const CardImage: React.FC<CardImageProps> = ({ product }) => {
  const mainImage = product.images?.[0];
  const hoverImage = product.images?.[1];

  return (
    <a href={product.permalink} aria-label={`View details for ${product.name}`}>
      {mainImage ? (
        <img
          src={mainImage.thumbnail}
          data-srcset={mainImage.srcset}
          data-sizes="auto"
          alt={mainImage.alt || product.name}
          className="product-card__image product-card__image--primary lazyload"
        />
      ) : (
        <div className="product-card__image-placeholder"></div>
      )}
      {hoverImage && (
        <img
          src={hoverImage.thumbnail}
          data-srcset={hoverImage.srcset}
          data-sizes="auto"
          alt={hoverImage.alt || product.name}
          className="product-card__image product-card__image--secondary lazyload"
          aria-hidden="true"
        />
      )}
    </a>
  );
};

export default CardImage;
